import { DecodeHtml } from "../../utils/decodeHtml";
import { retrunAssets } from "../../utils/getAssets";
import Heading from "../heading"
import Purpose from "./purpose"
import StudentGuideLine from "./studentGuideLine"
import { PropTypes } from 'prop-types';

const ExchangeAndMobility = ({ internationalOffice }) => {

    const title = internationalOffice?.section2title
    const description = DecodeHtml({ html: internationalOffice?.description1?.markup })
    const image = internationalOffice?.image1 != null ? retrunAssets(internationalOffice?.image1[0]?.url) : ""
    const purpose = DecodeHtml({ html: internationalOffice?.description2?.markup })
    const gemCategory = DecodeHtml({ html: internationalOffice?.description3?.markup })
    return (
        <div className="flex justify-center bg-[#F2F3F4] p-4 md:py-8 w-full">
            <div className="flex flex-col w-full gap-5 lg:px-16  ">
                <div className="flex w-full flex-col gap-5 items-center ">
                    <Heading name="360 GEM" color="text-blue-600" />
                    <h1 className="w-auto text-2xl font-bold text-slate-900  2xl:text-5xl leading-tight">{title}</h1>
                    <p className='whitespace-pre-line w-full'>
                    {
                        description
                    }
                    </p>
                    <Purpose image={image} purpose={purpose} gemCategory={gemCategory}  />
                    <StudentGuideLine internationalOffice={internationalOffice} />
                </div>
            </div>

        </div>
    )
}
ExchangeAndMobility.propTypes = {
    internationalOffice: PropTypes.object
}
export default ExchangeAndMobility